import { connect } from 'react-redux';

import { CUSTOMER_ADDRESS } from 'Component/CheckoutAddressForm/CheckoutAddressForm.config';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'Component/MyAccountAddressForm/MyAccountAddressForm.container';
import {
    CheckoutAddressFormContainer as SourceCheckoutAddressFormContainer
} from 'SourceComponent/CheckoutAddressForm/CheckoutAddressForm.container';
import { updateForm } from 'Store/Checkout/Checkout.action';
import BrowserDatabase from 'Util/BrowserDatabase/BrowserDatabase';

import CheckoutAddressForm from './CheckoutAddressForm.component';

/** @namespace Bodypwa/Component/CheckoutAddressForm/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    updateForm: (form) => dispatch(updateForm(form))
});
/** @namespace Bodypwa/Component/CheckoutAddressForm/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    ...state.CheckoutReducer
});

/** @namespace Bodypwa/Component/CheckoutAddressForm/Container */
export class CheckoutAddressFormContainer extends SourceCheckoutAddressFormContainer {
    containerAdditionalFunctions = {
        onCustomerDataFieldsChange: this.onCustomerDataFieldsChange.bind(this)
    };

    onCustomerDataFieldsChange(data) {
        const { updateForm } = this.props;
        if (data.street_0) {
            const address = data;
            updateForm({ ...this.state, ...address, address });
            this.setState({ ...address, address });
        } else {
            updateForm({ ...this.state, ...data });
            this.setState({ ...data });
        }
    }

    state = {
        countryId: this.getCountry()?.value || 'US',
        availableRegions: this.getAvailableRegions() || [],
        isStateRequired: !!this.getCountry()?.is_state_required,
        currentCity: null,
        currentRegion: null,
        currentZipcode: null,
        currentRegionId: null
    };

    componentWillMount() {
        const { updateForm } = this.props;
        const customerAddress = BrowserDatabase.getItem(CUSTOMER_ADDRESS);
        updateForm({ ...customerAddress });
        this.setState({ ...this.state, ...customerAddress });
    }

    componentDidUpdate() {
        const customerAddress = BrowserDatabase.getItem(CUSTOMER_ADDRESS);
        const email = customerAddress ? customerAddress.email : '';
        BrowserDatabase.setItem({ ...customerAddress, ...this.state, email }, CUSTOMER_ADDRESS);
    }

    containerProps() {
        const {
            onShippingEstimationFieldsChange,
            firstname,
            lastname,
            telephone,
            region_id,
            postcode,
            city,
            currentRegionId,
            region,
            currentRegion,
            address
        } = this.props;

        return {
            ...super.containerProps(),
            ...address,
            firstname,
            lastname,
            telephone,
            region_id,
            postcode,
            city,
            currentRegionId,
            onShippingEstimationFieldsChange,
            region,
            currentRegion,
            address
        };
    }

    render() {
        return (
            <CheckoutAddressForm
              { ...this.containerFunctions }
              // eslint-disable-next-line @scandipwa/scandipwa-guidelines/jsx-no-props-destruction
              { ...this.containerAdditionalFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutAddressFormContainer);
